/**
 * FG-5 · WorkModeFg5Cta — collapsed under GC60 One-Front-Door corrective
 * programme (2026-07-25).
 *
 * The historical "Start a multi-camera lesson recording" CTA is now the
 * SAME action as every other Founder upload: import today's recordings
 * from wherever they live (SD card, dashcam, phone). The system decides
 * how to group them.
 */
import { useNavigate } from "react-router-dom";
import { Film, ChevronRight } from "lucide-react";

export default function WorkModeFg5Cta() {
  const nav = useNavigate();
  return (
    <button
      type="button"
      data-testid="fg5-workmode-cta"
      onClick={() => nav("/import-todays-recordings")}
      className="w-full text-left rounded-2xl border border-slate-700 bg-slate-800/60 hover:border-slate-500 px-4 py-3 flex items-center gap-3 transition-colors"
    >
      <div className="w-10 h-10 rounded-xl bg-blue-600/20 flex items-center justify-center shrink-0">
        <Film className="w-5 h-5 text-blue-300" aria-hidden="true" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-white leading-tight">Import today's recordings</p>
        <p className="text-xs text-slate-400 leading-tight">
          One place — I'll sort out what belongs where.
        </p>
      </div>
      <ChevronRight className="w-4 h-4 text-slate-400" aria-hidden="true" />
    </button>
  );
}
